// frame: uJtA2 @ ui/dogdisk-user.pen 弹框-二维码
// 触发:`MvLuo qrBtn (lfqEc)` / `FB0fg qrBtn (simuZ)` / `ondv5 action3 (1jgM0)`
// 实现:走 server-side GET /gapi/user/util/qr?text=... 返 PNG(避免前端引入 qrcode 包依赖)
//
// 若后端 endpoint 未实装,saveBtn 显示降级提示。

export type QrCodeModalProps = {
  open: boolean
  onClose: () => void
  /** 要编码到 QR 的文本(分享链接 / 资源包 URL 等) */
  text: string
  /** 顶部标题,默认 "扫码分享" */
  title?: string
}

export function QrCodeModal({ open, onClose, text, title = '扫码分享' }: QrCodeModalProps) {
  if (!open) return null

  const qrUrl = `/gapi/user/util/qr?text=${encodeURIComponent(text)}&size=200`

  const onSave = async () => {
    try {
      const res = await fetch(qrUrl)
      if (!res.ok) return
      const blob = await res.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'qr-code.png'
      a.click()
      URL.revokeObjectURL(url)
    } catch {
      // 静默
    }
  }

  return (
    <div
      data-frame-id="uJtA2"
      data-testid="uJtA2"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      className="fixed inset-0 z-50 flex items-end bg-black/50"
      onClick={onClose}
    >
      <div
        className="mx-auto w-full max-w-[402px] rounded-t-3xl bg-white"
        style={{ paddingBottom: 'max(34px, env(safe-area-inset-bottom))' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-center pt-2 pb-3">
          <span className="h-1 w-10 rounded-full bg-[#E0E0E0]" />
        </div>
        <header className="px-6 py-2 text-center">
          <h2 className="text-[15px] font-semibold text-[#1A1A1A]">{title}</h2>
          <p className="mt-0.5 text-[11px] text-[#9CA3AF]">扫描二维码即可访问分享内容</p>
        </header>
        <div className="flex flex-col items-center gap-3 px-6 py-4">
          <img
            src={qrUrl}
            alt="QR code"
            data-testid="uJtA2-canvas"
            className="h-[200px] w-[200px] rounded-lg border border-[#F1F2F4]"
            width={200}
            height={200}
          />
          <p
            data-testid="uJtA2-link"
            className="break-all rounded bg-[#F6F7F8] px-3 py-1.5 text-center text-[11px] text-[#6B7280]"
          >
            {text}
          </p>
        </div>
        <div className="flex gap-2 px-6 pb-3">
          <button
            type="button"
            data-testid="uJtA2-cancel"
            onClick={onClose}
            className="h-11 flex-1 rounded-lg bg-[#F1F2F4] text-[14px] font-semibold text-[#1A1A1A]"
          >
            关闭
          </button>
          <button
            type="button"
            data-testid="uJtA2-save"
            onClick={onSave}
            className="h-11 flex-1 rounded-lg bg-[#19caad] text-[14px] font-semibold text-white active:bg-[#14a18b]"
          >
            保存到相册
          </button>
        </div>
      </div>
    </div>
  )
}
